import styled from "styled-components";


export const CardHeader = styled.div`
  :first-child {
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
  }
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  margin-bottom: 0;
  padding: 0.5rem 1rem;
`;